<template>
  <layout-main-inner
    title="安全库存"
    class="stat-inventory">
    <div slot="action">
      <el-date-picker
        v-model="query.month"
        style="width: 140px"
        type="month"
        placeholder="选择月"
        format="yyyy 年 MM 月"
        :clearable="false"
        :editable="false"
        @change="fetch">
      </el-date-picker>
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="fetch">查询</el-button>
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">本期数据</template>
      <el-row>
        <el-col :span="24">
          <summary-list
            :span="6"
            :list="summaryList" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-row>
            <el-col :span="24">
              <v-title title="本期各产品安全库存情况（前20名）">
                <el-tooltip
                  slot="append"
                  effect="dark"
                  content="点击图表上的柱子可以切换产品，查看明细"
                  placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </v-title>
              <safe-sku-chart
                :index="stock.selectedIndex"
                :xAxis="stock.xAxis"
                :series1="stock.series1"
                :series2="stock.series2"
                @setIndex="setSkuIndex" />
            </el-col>
            <el-col :span="24">
              <v-title
                title="本期各产品安全库存明细"
                style="margin-top: 8px">
                <span
                  v-if="skuName"
                  style="font-weight: 700">({{ skuName }})</span>
              </v-title>
              <safe-sku-detail-table
                :list="skuList.stockSafetyDetails" />
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <v-title title="本期各仓库安全库存情况（20名以后）">
            <el-tooltip
              slot="append"
              effect="dark"
              content="点击列表行可以切换产品，查看明细"
              placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </v-title>
          <safe-sku-table
            :list="stock.list"
            @setIndex="setSkuIndex" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="14">
          <v-title title="本期各仓库安全库存情况">
            <el-tooltip
              slot="append"
              effect="dark"
              content="点击图表上的柱子可以切换仓库，查看明细"
              placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </v-title>
          <safe-ware-chart
            :index="stock1.selectedIndex"
            :xAxis="stock1.xAxis"
            :series1="stock1.series1"
            :series2="stock1.series2"
            @setIndex="setWareIndex" />
        </el-col>
        <el-col :span="10">
          <v-title title="本期各仓库安全库存明细">
            <span
              v-if="wareName"
              style="font-weight: 700">({{ wareName }})</span>
          </v-title>
          <safe-ware-table :list="wareList.stockSafetyDetails" />
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SummaryList from './busi/summary.vue'
import VTitle from './v-title.vue'

import SafeSkuChart from './safe/safe-sku-chart.vue'
import SafeSkuTable from './safe/safe-sku-table.vue'
import SafeSkuDetailTable from './safe/safe-sku-detail-table.vue'
import SafeWareChart from './safe/safe-ware-chart.vue'
import SafeWareTable from './safe/safe-ware-table.vue'

const SLICE_NUM = 20
export default {
  name: 'StatInventory',
  components: { SummaryList, SafeSkuChart, SafeSkuTable, SafeSkuDetailTable, SafeWareChart, SafeWareTable, VTitle },
  data() {
    return {
      loading: false,
      query: {
        month: +moment()
      },
      summaryList: [
        {
          label: '本期低于安全库存数',
          value: 0
        }
      ],
      stock: {
        xAxis: [],
        series1: [],
        series2: [],
        list: [],
        selectedIndex: 0,
        allList: []
      },
      stock1: {
        xAxis: [],
        series1: [],
        series2: [],
        list: [],
        selectedIndex: 0,
        allList: []
      }
    }
  },
  computed: {
    wareList() {
      const { selectedIndex, allList } = this.stock1
      return allList[selectedIndex] || {}
    },
    wareName() {
      const wareList = this.wareList
      return wareList.warehouseName
    },
    skuList() {
      const { selectedIndex, allList } = this.stock
      return allList[selectedIndex] || {}
    },
    skuName() {
      const skuList = this.skuList
      return skuList.productName
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    setWareIndex(index) {
      this.stock1.selectedIndex = index
    },
    setSkuIndex(index) {
      this.stock.selectedIndex = index
    },
    fetch() {
      this.loading = true
      const { month } = this.query
      this.$store.dispatch('stat/sumstocksafety', {
        payload: {
          beginDate: moment(month).startOf('month').format('YYYYMMDD'),
          endDate: moment(month).endOf('month').format('YYYYMMDD')
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '本期低于安全库存数',
              value: res.data.lowSafetyStockCount
            }
          ])
          this.formatProductData(res.data.productStockSafetySums)
          this.formatWarehouseData(res.data.warehouseStockSafetySums)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    formatProductData(detail) {
      const stockAllList = []
      detail.forEach(i => {
        const { productName, lowSafetyStockCount, stockCount, stockSafetyDetails } = i
        stockAllList.push({
          productName, lowSafetyStockCount, stockCount, stockSafetyDetails,
          highSafetyStockCount: stockCount - lowSafetyStockCount
        })
      })
      const stockList = _.sortBy(stockAllList, (i) => -i.stockCount)
      this.stock.allList = stockList
      const chartList = stockList.slice(0, SLICE_NUM)
      this.stock.xAxis = chartList.map(i => i.productName)
      this.stock.series1 = chartList.map(i => i.lowSafetyStockCount)
      this.stock.series2 = chartList.map(i => i.highSafetyStockCount)
      this.stock.list = stockList.slice(SLICE_NUM)
    },
    formatWarehouseData(detail) {
      const stockAllList = []
      detail.forEach(i => {
        const { warehouseName, lowSafetyProductCount, productCount, stockSafetyDetails } = i
        stockAllList.push({
          warehouseName, lowSafetyProductCount, productCount, stockSafetyDetails,
          highSafetyProductCount: productCount - lowSafetyProductCount
        })
      })
      const chartList = _.sortBy(stockAllList, (i) => -i.productCount)
      this.stock1.allList = chartList
      this.stock1.xAxis = chartList.map(i => i.warehouseName)
      this.stock1.series1 = chartList.map(i => i.lowSafetyProductCount)
      this.stock1.series2 = chartList.map(i => i.highSafetyProductCount)
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
